'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.arrayOf(_propTypes2.default.shape({
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  src: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.oneOf(['vast', 'vmap'])
})); /**
      * Copyright 2017, Hudl
      * All rights reserved.
      *
      * This source code is licensed under the BSD-style license found in the
      * LICENSE file in the root directory of this source tree. An additional grant
      * of patent rights can be found in the PATENTS file in the same directory.
      *
      * @providesModule AdsPropType
      */

module.exports = exports['default'];